import {
  axiosInstance,
  GET_ADAPTIVE_LEARNING,
  GET_ADAPTIVE_LEARNING_CONTENT,
  GET_ADAPTIVE_LEARNING_CONTENT_BY_ID,
  GET_ADAPTIVE_LEARNING_TEST,
  GET_ALL_ADAPTIVE_LEARNING_CONTENT,
  SUBMIT_ADAPTIVE_LEARNING_TEST,
  REGENERATE_ADAPTIVE_LEARNING_CONTENT,
} from "../apiurls/apiurls";

export const getAllAdaptiveData = async () => {
  try {
    const response = await axiosInstance.get(GET_ALL_ADAPTIVE_LEARNING_CONTENT);
    return response.data;
  } catch (error) {
    console.error("Error fetching adaptive learning data:", error);
    throw error;
  }
};

export const getAdaptiveLearningById = async (id) => {
  try {
    const response = await axiosInstance.get(
      GET_ADAPTIVE_LEARNING_CONTENT_BY_ID,
      {
        params: { id },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching adaptive learning content:", error);
    throw error;
  }
};

export const getAdaptiveLearning = async (id) => {
  try {
    const response = await axiosInstance.get(`${GET_ADAPTIVE_LEARNING}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching adaptive learning:", error);
    throw error;
  }
};

export const getAdaptiveLearningContent = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ADAPTIVE_LEARNING_CONTENT}/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching adaptive learning content:", error);
    throw error;
  }
};

export const getAdaptiveLearningTest = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ADAPTIVE_LEARNING_TEST}/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching adaptive learning test:", error);
    throw error;
  }
};

export const submitAdaptiveLearningTest = async (id, payload) => {
  try {
    const response = await axiosInstance.post(
      `${SUBMIT_ADAPTIVE_LEARNING_TEST}?page=${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting adaptive learning test:", error);
    throw error;
  }
};

export const regenerateAdaptiveLearningContent = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${REGENERATE_ADAPTIVE_LEARNING_CONTENT}/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error regenerating adaptive learning content:", error);
    throw error;
  }
};

